import { Box, IconButton, MenuItem, Select } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function RichTextEditor({
  copyToClipboard,
  undo,
  redo,
  fontFamilies,
  setSelectedFont,
  setFontSize,
}) {
  return (
    <div className="flex">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton size="small" onClick={undo}>
          <UndoIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={redo}>
          <RedoIcon fontSize="small" />
        </IconButton>
        <Select
          size="small"
          onChange={(e) => setSelectedFont(e.target.value)}
          defaultValue={fontFamilies[0]}
          style={{
            fontSize: '14px',
            padding: '0px',
          }}
        >
          {fontFamilies.map((font) => (
            <MenuItem key={font} value={font}>
              {font}
            </MenuItem>
          ))}
        </Select>

        <Select
          size="small"
          onChange={(e) => setFontSize(Number(e.target.value))}
          defaultValue={16}
          style={{
            fontSize: '14px',
            padding: '0px',
          }}
        >
          {[12, 14, 16, 18, 20, 24, 28, 32, 36].map((size) => (
            <MenuItem key={size} value={size}>
              {size}px
            </MenuItem>
          ))}
        </Select>
        <IconButton size="small" onClick={() => copyToClipboard(true)}>
          <ContentCutIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={() => copyToClipboard()}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Box>
    </div>
  );
}
